import { render, staticRenderFns } from "./IconHeader.vue?vue&type=template&id=124cc5b6&scoped=true"
import script from "./IconHeader.vue?vue&type=script&lang=js"
export * from "./IconHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124cc5b6",
  null
  
)

export default component.exports